import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMenuStore = defineStore('menu', () => {
  const isDropdownOpen = ref<boolean>(false);
  const isAccessControlOpen = ref<boolean>(false);
  const isParameterOpen = ref<boolean>(false);
  const isSupplierOpen = ref<boolean>(false);
  const isWarehouseOpen = ref<boolean>(false);
  const isProductOpen = ref<boolean>(false);
  const isQuotationOpen = ref<boolean>(false);
  const isPurchaseOpen = ref<boolean>(false);
  const isStockOpen = ref<boolean>(false);
  const isCustomerOpen = ref<boolean>(false);
  const isSalesOpen = ref<boolean>(false);
  const isSalesReturnOpen = ref<boolean>(false);
  const isTransferOpen = ref<boolean>(false);
  const isAdjustmentOpen = ref<boolean>(false);
  const isPosOpen = ref<boolean>(false);
  const isCurrencyOpen = ref<boolean>(false);
  const isBarCodeOpen = ref<boolean>(false);
  const isAccountsOpen = ref<boolean>(false);
  const isReportOpen = ref<boolean>(false);
  const isDiscountOpen = ref<boolean>(false);
  const isShipmentOpen = ref<boolean>(false);
  const isBannerOpen = ref<boolean>(false);
  const isCollectionOpen = ref<boolean>(false);
  const isMenuOpen = ref<boolean>(false);
  const isSubMenuOpen = ref<boolean>(false);
  const isOrderOpen = ref<boolean>(false);
  const rootLink = ref<string|null>(null);
  const subSubLink = ref<string|null>(null);
  const parentLink = ref<string|null>(null);
  const childLink = ref<string|null>(null);

  const toggleIsMenuOpen = (): void => {
    isMenuOpen.value = !isMenuOpen.value;
    isSubMenuOpen.value = false;
    isDropdownOpen.value = false;
    isAccessControlOpen.value = false
    isParameterOpen.value = false;
    isSupplierOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  }

  const toggleIsSubMenuOpen = (): void => {
    isSubMenuOpen.value = !isSubMenuOpen.value;
    isMenuOpen.value = true;
    isDropdownOpen.value = false;
    isAccessControlOpen.value = false
    isParameterOpen.value = false;
    isSupplierOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  }

  const toggleDropdown = (): void => {
    isDropdownOpen.value = !isDropdownOpen.value;
    isAccessControlOpen.value = false
    isParameterOpen.value = false;
    isSupplierOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleAccessControl = (): void => {
    isAccessControlOpen.value = !isAccessControlOpen.value;
    isDropdownOpen.value = false
    isParameterOpen.value = false;
    isSupplierOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleParameter = (): void => {
    isParameterOpen.value = !isParameterOpen.value
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isSupplierOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleSupplier = (): void => {
    isSupplierOpen.value = !isSupplierOpen.value;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleWarehouse = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = !isWarehouseOpen.value;
    isProductOpen.value = false;
    isQuotationOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleProduct = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isProductOpen.value = !isProductOpen.value;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleQuotation = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = !isQuotationOpen.value;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const togglePurchase = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isStockOpen.value = false;
    isPurchaseOpen.value = !isPurchaseOpen.value;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleStock = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = !isStockOpen.value;
    isCustomerOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleCustomer = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isCustomerOpen.value = !isCustomerOpen.value;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleSales = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesReturnOpen.value = false;
    isTransferOpen.value = false;
    isSalesOpen.value = !isSalesOpen.value;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleSalesReturn = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false;
    isSalesReturnOpen.value = !isSalesReturnOpen.value;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleTransfer = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = !isTransferOpen.value;
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleAdjustment = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = !isAdjustmentOpen.value;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const togglePos = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = !isPosOpen.value;
    isCurrencyOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleCurrency = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isBarCodeOpen.value = false;
    isAccountsOpen.value = false;
    isCurrencyOpen.value = !isCurrencyOpen.value;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleBarCode = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = !isBarCodeOpen.value;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleAccounts = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = !isAccountsOpen.value;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleReport = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isDiscountOpen.value = false;
    isReportOpen.value = !isReportOpen.value;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleDiscount = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = !isDiscountOpen.value;
    isShipmentOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleShipment = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isBannerOpen.value = false;
    isCollectionOpen.value = false;
    isShipmentOpen.value = !isShipmentOpen.value;
    isOrderOpen.value = false;
  };

  const toggleBanner = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isBannerOpen.value = !isBannerOpen.value;
    isShipmentOpen.value = false;
    isCollectionOpen.value = false;
    isOrderOpen.value = false;
  };

  const toggleProductCollection = (): void => {
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isBannerOpen.value = false
    isShipmentOpen.value = false;
    isCollectionOpen.value = !isCollectionOpen.value;
    isOrderOpen.value = false;
  };

  const toggleOrder = (): void => {
    isOrderOpen.value = !isOrderOpen.value;
    isSupplierOpen.value = false;
    isParameterOpen.value = false
    isAccessControlOpen.value = false;
    isDropdownOpen.value = false;
    isWarehouseOpen.value = false;
    isQuotationOpen.value = false;
    isProductOpen.value = false;
    isPurchaseOpen.value = false;
    isStockOpen.value = false;
    isSalesOpen.value = false;
    isTransferOpen.value = false
    isSalesReturnOpen.value = false;
    isAdjustmentOpen.value = false;
    isPosOpen.value = false;
    isCurrencyOpen.value = false;
    isAccountsOpen.value = false;
    isBarCodeOpen.value = false;
    isReportOpen.value = false;
    isDiscountOpen.value = false;
    isBannerOpen.value = false
    isShipmentOpen.value = false;
    isCollectionOpen.value = false;
  };

  return {
    isDropdownOpen,
    isAccessControlOpen,
    isParameterOpen,
    isSupplierOpen,
    isWarehouseOpen,
    isProductOpen,
    isQuotationOpen,
    isPurchaseOpen,
    isStockOpen,
    isCustomerOpen,
    isSalesOpen,
    isSalesReturnOpen,
    isTransferOpen,
    isAdjustmentOpen,
    isPosOpen,
    isCurrencyOpen,
    isBarCodeOpen,
    isAccountsOpen,
    isReportOpen,
    isDiscountOpen,
    isShipmentOpen,
    isBannerOpen,
    isCollectionOpen,
    isMenuOpen,
    isSubMenuOpen,
    rootLink,
    subSubLink,
    parentLink,
    childLink,
    isOrderOpen,
    toggleOrder,
    toggleDropdown,
    toggleAccessControl,
    toggleParameter,
    toggleSupplier,
    toggleWarehouse,
    toggleProduct,
    toggleQuotation,
    togglePurchase,
    toggleStock,
    toggleCustomer,
    toggleSales,
    toggleSalesReturn,
    toggleTransfer,
    toggleAdjustment,
    togglePos,
    toggleCurrency,
    toggleBarCode,
    toggleReport,
    toggleAccounts,
    toggleDiscount,
    toggleShipment,
    toggleBanner,
    toggleProductCollection,
    toggleIsMenuOpen,
    toggleIsSubMenuOpen
  };
});